var map = {
	"./icon-01.png": "ZJ7F",
	"./icon-02.png": "/pWW",
	"./icon-03.png": "21tc",
	"./icon-04.png": "pkXT",
	"./icon-05.png": "I8jB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YcNX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-it-works ^\.\/.*$
// module id = YcNX
// module chunks = 1